import { LogOut } from "lucide-react";
import type React from "react";
import { useNavigate } from "react-router-dom";

const Dropdown: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();

    // Redirect to login page
    navigate("/admin/login");
  };

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        <div className="relative">
          <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-black font-semibold text-sm">
            A
          </div>

          <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div>
        </div>
        <span className="text-sm font-medium text-white">Admin</span>
      </div>

      {/* Logout button */}
      <button
        onClick={handleLogout}
        className="p-2 rounded-md text-white hover:bg-white/20 hover:text-white transition-colors"
        title="Log Out"
      >
        <LogOut size={18} />
      </button>
    </div>
  );
};

export default Dropdown;
